import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * 目次一覧API
 * @param  {} params={}
 */
export const table = (params = {}) => {

  let path
  if (store.state.common.device === 'sp') {
    path = 'GU/005'
  } else {
    path = 'GU/001'
  }

  const defaults = {
    _path: path,
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * ご利用ガイド一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {

  let path
  if (store.state.common.device === 'sp') {
    path = 'GU/006'
  } else {
    path = 'GU/002'
  }

  const defaults = {
    _path: path,
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * ご利用ガイド一覧件数取得API
 * @param  {} params={}
 */
export const count = (params = {}) => {

  let path
  if (store.state.common.device === 'sp') {
    path = 'GU/008'
  } else {
    path = 'GU/004'
  }

  const defaults = {
    _path: path,
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * ご利用ガイド詳細API
 * @param  {} params={}
 */
export const detail = (params = {}) => {

  let path
  if (store.state.common.device === 'sp') {
    path = 'GU/007'
  } else {
    path = 'GU/003'
  }

  const defaults = {
    _path: path,
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


// 印刷用PDF情報取得
export const getPrintPDF = (params = {}) => {
  const defaults = {
    _path: 'GU/009',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
